import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/lots")({
  component: LotsLayout,
});

function LotsLayout() {
  return <Outlet />;
}
